import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";

export default function PediatricConference({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: '温州医科大学附属眼视光医院＆集视医疗战略合作签约',
      date: '2024-10-31',
      desc: '2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室…',
      img: '/images/news/news1.png',
      route: '/newsInfo/contract'
    },
    {
      title: '集视医疗亮相中华医学会第二十八次眼科学术大会',
      date: '2024-09-04',
      desc: '2024年9月4-8日，中华医学会第二十八次眼科学术大会在武汉国际博览中心隆重举行，作为年度眼科行业最盛大的学术会议，全球逾万名专家、学者相聚于此，交流分享眼科和视觉科学方面最新研究成果…',
      img: '/images/news/academic3.png',
      route: '/newsInfo/academic'
    },
    {
      title: '集视医疗完成Pre-A轮融资',
      date: '2024-08',
      desc: '据悉，集视医疗已于近期完成由复健资本独家投资的Pre-A轮融资。随着本轮资金的成功注入，集视医疗将大幅提升产能，不断巩固和拓展其全年龄段弱视治疗方案，扎实推进已获批产品的商业化进程…',
      img: '/images/news/news4.png',
      route: '/newsInfo/pre'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div className="PreA">
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 突破弱视诊疗年龄瓶颈，集视医疗携脑科学驱动方案亮相全国小儿眼科年会</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className='article_title'>
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2026.06</span>
              </div>
              <div className="article_titleBottom">突破弱视诊疗年龄瓶颈，集视医疗携脑科学驱动方案亮相全国小儿眼科年会</div>
            </div>
            <div className='article_content'>
              <div className="article_content-text">
                以“脑科学机制驱动・眼脑融合创新”为核心定位的集视医疗，在2026中华医学会斜视与小儿眼科学术大会上精彩亮相，向业界展示了旗下基于脑科学机制的弱视治疗解决方案——埃尔塔（ARTA），与全国眼科专家共探弱视诊疗前沿路径，引发行业广泛关注与认可。
              </div>
              <div className='article_content-text1'>01 大咖云集，共话弱视治疗新征程</div>
              <div className='article_content-text'>
                弱视，作为儿童脑科学机制研究的最常见的致盲性眼病之一，长期以来被认为12岁后视觉系统定型，治疗效果微乎其微。然而，随着神经视觉科学的突破性进展，这一传统认知正在被颠覆！<br /><br />
                在本次全年龄段弱视诊疗临床专题会上，国内顶尖眼科专家齐聚一堂，共同探讨弱视治疗的前沿技术与临床实践，为广大眼科同仁带来一场学术盛宴。<br />
                会议伊始由天津市眼科医院张伟教授开场致辞。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/pediatricConference1.png'
                  alt=''
                />
              </div>
              <div className='article_content-text'>
                张教授指出，近年来儿童屈光相关问题高发，而幼年异常的屈光状态是弱视最大的诱因。目前弱视治疗存在显著年龄瓶颈，大龄弱视（12岁以上）仍是临床诊疗的核心难点。国内外相关探索性研究逐渐增多，但基础研究向临床应用的转化率极低；文雯教授和李志刚教授长期致力于弱视神经病理机制的研究与转化工作，其成果非常值得大家学习。<br /><br />
                专家分享环节干货满满、金句迭出，前沿观点直击核心，现场反响热烈。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/pediatricConference2.png'
                  alt=''
                />
              </div>
              <div className='article_content-text'>
                <div style={{ fontWeight: 'bold' }}>文雯教授：大龄弱视治疗的突破与转化实践</div>
                <span style={{ fontWeight: 'bold' }}>复旦大学附属眼耳鼻喉科医院文雯教授，</span>带来《大龄弱视治疗突破和转化实践》的精彩分享。<br /><br />
                文教授指出，临床医生进行科研工作的价值在于反哺临床。本团队从弱视基础研究出发，首次揭示大龄弱视患者的神经病理机制——外膝体-V1小细胞通路功能异常；在此基础之上，主导完成了从小样本探索性IIT研究到大规模RCT临床试验。<br /><br />
                既往IIT研究已证实：仅需6个月标准化训练，埃尔塔弱视训练对12岁以下儿童弱视的治疗有效率即超90%，对18岁以上成人弱视的有效率达77.3%，疗效显著优于传统遮盖疗法及所有已获FDA批准的同类疗法。<br /><br />
                最新RCT中期分析结果进一步验证：本研究采用与金标准遮盖疗法的头对头对照设计，经过3个月标准化训练，成人组有效率达60%，显著优于遮盖对照组，达到预设的优效性终点。<br /><br />
                值得强调的是，本研究建立了全面的弱视临床疗效评价体系：不仅以视力提升为核心指标，同时系统观测了拥挤效应、对比敏感度(CSF)、双眼融合功能、立体视功能、脑电活动及fMRI脑功能成像等多维度客观指标，全面评估患者的神经视觉康复状态。
                尤为突出的是，在双眼融合与立体视功能恢复方面，埃尔塔方案展现出明显优势：自第一次访视期起，即出现统计学显著提升，且提升幅度优于传统遮盖疗法。随着训练周期的延长，我们有充分依据预判，基于双眼小细胞通路推拉范式的训练方案临床疗效将持续提升，有望为全年龄段弱视患者带来更优的治疗结局。<br /><br />
                这一核心机制，正是集视医疗埃尔塔（ARTA）的技术内核。埃尔塔独创“双眼+双通路”推拉训练方案，精准定向训练弱视眼受损的小细胞通路（P通路）感知能力，同时屏蔽大细胞通路（M通路）对优势眼的信号抑制，重建双眼信息感知平衡，从根源上突破传统弱视治疗的年龄限制。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/pediatricConference3.png'
                  alt=''
                />
              </div>
              <div className='article_content-text'>
                <div style={{ fontWeight: 'bold' }}>李志刚教授：rTMS技术——基于中枢神经机制的弱视治疗新探索</div>
                <span style={{ fontWeight: 'bold' }}>郑州大学第一附属医院李志刚教授，</span>分享了《基于中枢神经机制的弱视治疗探索——rTMS技术临床应用研究》。<br /><br />
                大龄弱视一直以来都是临床亟待攻克的问题，但攻克难题的前提是对弱视的中枢机制有足够的认识。综合来看，弱视患者同时存在中枢+外周双重神经损伤；rTMS技术通过无创刺激中枢神经，为全年龄弱视患者提供了治疗新手段。<br /><br />
                而集视医疗埃尔塔（ARTA）同样深度融合中枢神经调控逻辑，依托增强现实（AR）技术，将日常画面（读书、写字、观影）实时转化为个性化治疗场景，让患者在生活中完成训练，依从性大幅提升。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/pediatricConference4.png'
                  alt=''
                />
              </div>
              <div className='article_content-text'>
                作为本场专题会议的主持人，中山大学中山眼科中心余新平教授高度认可文雯教授的科研成果转化成效。余教授表示：一项基础研究能够实现从书架到货架的转换，真正服务患者而非束之高阁，是非常难得的。现阶段相关研究成果已投入特定人群临床探索，未来可期！
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/pediatricConference5.png'
                  alt=''
                />
              </div>
              <div className='article_content-text1'>02 独立展台：沉浸式体验脑视觉创新科技</div>
              <div className='article_content-text'>
                展会期间，集视医疗展位人气持续高涨，众多行业专家、同仁驻足交流。我们通过实物展示、AR设备现场体验、临床案例解析等多元形式，全方位呈现了埃尔塔以脑科学机制研究驱动弱视治疗方案的技术原理与临床价值。<br /><br />
                <div style={{ fontWeight: 'bold' }}>核心亮点：</div>
                <span style={{ fontWeight: 'bold' }}>脑科学基础：</span>首个基于全新脑视觉机制的弱视治疗方案，突破传统治疗局限；<br />
                <span style={{ fontWeight: 'bold' }}>AR技术赋能：</span>自主研发的AR眼镜设备，实现个性化、沉浸式视觉训练，提升治疗依从性与效果；<br />
                <span style={{ fontWeight: 'bold' }}>全龄覆盖：</span>打破“12岁后弱视无法治疗”的传统认知，为大龄弱视患者带来新希望。<br /><br />
                现场体验区排起长队，不少体验者表示：<br />
                “埃尔塔的‘双眼+双通路’推拉训练方案是对传统视训的革新，对于既往临床难以处理的痛点问题（例如：大龄成人弱势患者/形觉剥夺型患者/残余性弱势患者等），给出了前沿解决方案。”<br /><br />
                "AR眼镜训练形式新颖，互动性强，不受空间限制，将日常生活（读书、写字、观影）实时转化为个性化治疗场景，比传统训练更有趣，孩子更容易接受。"
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/pediatricConference6.png'
                  alt=''
                />
              </div>
              <div className='article_content-text1'>03 学术共研：深度解析弱视治疗前沿方向</div>
              <div className='article_content-text'>
                在学术共研交流环节，3位领域内专家现场开讲，结合自身研究成果与临床实践，带来了干货满满的分享，并与现场同仁展开深度探讨，碰撞学术思想，共促行业发展。
              </div>
              <div className='article_content-text'>
                <span style={{ fontWeight: 'bold' }}>中科院生物物理所 认知神经科学博士高弋戈，</span>分享《通过数字手段支配现实图像以进行视觉干预》，高博士指出，利用视觉特征进行视觉训练历史非常悠久，但既往的方式都局限于通过简单视觉特征进行任务式训练；
                集视以AR革新视训，一是基于增强现实技术实现对现实图像的直接修改，实现融入日常生活的训练方式，二是能够处理复杂高级视觉特征，实现通过视觉训练改善多种视力/视功能缺陷，相关技术已实现在弱视治疗的应用，未来会逐步拓展到近视、青光眼等更多疾病领域。<br /><br />
                <span style={{ fontWeight: 'bold' }}>四川大学华西医院 廖咏川教授，</span>聚焦《AI赋能双眼数字疗法助力儿童弱视治疗》，廖教授结合临床案例，详解了弱视病理复杂，还伴随多项视功能损害，传统的遮盖以及配合遮盖的训练方案难以实现真正意义上的弱视康复。
                双眼分视数字治疗近年来发展突飞猛进，且指南地位快速提高，能解决很多既往临床难以处理的问题。未来双眼分视数字疗法需深度结合AI，真正做到一人一策的个性化治疗方案的定制，为弱视患者提供更好的治疗方式。<br /><br />
                <span style={{ fontWeight: 'bold' }}>中南大学湘雅医院 闵晓珊教授，</span>分享了《先白术后弱视训练思路》，闵教授表示：从儿童视力发育看，先天性白内障长期遮挡视轴，先白术后眼睛虽能感知高质量外界信息，但视力发育无捷径，每一步训练都不可或缺。
                既往先白性弱视视力难提升，多因训练未立足发育规律，单纯增加时长强度反而适得其反。而基于小细胞通路功能重建训练，契合患者需求。本次分享的病例为单眼先白术后弱视，既往治疗数年无效，经过AR双眼双通路推拉训练58天弱眼视力从0.6提升至0.8，可以为后续先白术后弱视训练作为临床经典案例参考。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/pediatricConference7.png'
                  alt=''
                />
              </div>
              <div className='article_content-text'>
                此次展会，集视医疗不仅展示了脑科学与AR技术融合的创新成果，更通过学术交流与临床探讨，推动了全年龄段弱视诊疗的发展。<br /><br />
                未来，集视医疗将持续深耕脑科学与眼科诊疗的融合创新，以全年龄覆盖、脑机制驱动、AR生活化治疗的核心优势，为更多斜弱视患者带来新希望，助力眼科诊疗高质量发展！<br /><br />
                感谢所有莅临集视医疗展台、参与学术交流的专家、同仁与朋友们！期待下次盛会，与您再聚，共话眼科健康新未来！
              </div>
              <div className='mt_60 img_tip'>免责声明：本文内容仅供行业学术交流、学术研讨及专业医疗领域参考使用，不构成任何商业广告、产品宣传及诊疗行为推荐。</div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/jishiAllAgeAmblyopia'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/contract'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/jishiAllAgeAmblyopia'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/contract'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
